module.exports = __webpack_public_path__ + "img/GALLERY-CIAZ-6.f7fe44c7.jpg";